import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { omit, isNull } from 'lodash/fp';
import styled, { css } from 'styled-components';
import incorrectIcon from '../new-icons/incorrect-icon.svg';
import  {CheckMark} from '../components/PhoneNumber';
import {Asterisk} from "./contact-details";

const InputDiv = styled.div`
  display:flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  margin-bottom : 0.3rem !important;
  .form-control.is-invalid, .was-validated .form-control:invalid {
    border-color: #dc3545;
    padding-right: calc(1.5em + .75rem);
    background-image: url(${incorrectIcon}) !important;
    background-repeat: no-repeat;
    background-position: center right calc(.375em + .1875rem);
    background-size: calc(.45em + .75rem) calc(.45em + .375rem);
}
.form-control.is-valid, .was-validated .form-control:valid {
    background-position: center right calc(.375em + .1875rem) !important;
    background-image: none !important;

}
`;
const CustomInput = styled.input`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px
  width: 99%;
  ${props => !props.validationClass && css`
    :focus {
       box-shadow: 0 0 0 0.05rem ${props.primaryColor} !important;
    }
   `}
  .form-control.is-valid:focus {
    border-color: #80bdff !important;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25) !important;
  }
     &::placeholder { 
     color: ${(props) => (props.placeholderColor ? '#212529' : '')} !important;
     opacity: 1 !important; 
     text-transform: none;
}
`;

const Input = (props) => {
    const {
        error, value, readOnly, validate, common, visible,
    } = props;
    const [touched, setTouched] = useState(false);
    let validationClass = '';
    if (!validate) {
        if ((isNull(value) || !touched) && !error) {
            validationClass = '';
        } else if (error) {
            validationClass = 'is-invalid';
        } else if (value) {
            validationClass = 'is-valid';
        }
    }
    const onBlur = (e) => {
        setTouched(true);
        props.onBlur(e);
    };
    return (
        <InputDiv className="form-group">
            {validationClass === 'is-valid' ? <CheckMark common={common} /> : '' }
            <CustomInput
                validationClass={validationClass}
                className={`form-control ${validationClass}`}
                {...omit(['error', 'className', 'value', 'onBlur'], props)}
                value={value || ''}
                onBlur={onBlur}
                readOnly={readOnly}
                primaryColor={common.buttonColor}
            />
            <Asterisk visible={visible}>*</Asterisk>
        </InputDiv>
    );
};

Input.propTypes = {
    error: PropTypes.string,
    value: PropTypes.string,
    onBlur: PropTypes.func,
    readOnly: PropTypes.bool,
    validate: PropTypes.number,
    visible: PropTypes.bool,
};

Input.defaultProps = {
    error: '',
    value: '',
    onBlur: () => {},
    readOnly: false,
    validate: 0,
    visible: false,
};

export default Input;
